import { clsx } from 'clsx';
import { ReactNode } from 'react';

import { Typography } from './Typography';
import { AnchorCopyTooltip } from './AnchorCopyTooltip';

interface StoryblokHeadingProps extends ComponentCommonProps {
  variant?: '' | 'h3' | 'subheading' | 'h2';
  children: ReactNode;
  hasDescription?: boolean;
  id?: string;
}

export const StoryblokHeading = ({
  variant = 'h2',
  children,
  hasDescription,
  className,
  id,
}: StoryblokHeadingProps) => {
  const classNameByDescription = hasDescription ? 'pb-5' : 'pb-3 lg:pb-12';
  if (variant === 'subheading') {
    return (
      <Typography className={clsx('subheading',className, classNameByDescription)}>
        {children}
      </Typography>
    );
  }

  const classNamesByVariant = {
    h2: 'sm:pb-12',
    h3: 'lg:pb-7',
  };
  const classes = clsx(
    className,
    classNameByDescription,
    'lg:w-8/12',
    classNamesByVariant[variant || 'h2']
  );

  return (
    <Typography
      anchorCopyTooltip={<AnchorCopyTooltip id={id} />}
      id={id}
      as={variant || 'h2'}
      className={classes}
    >
      {children}
    </Typography>
  );
};
